import { IconLeftBottomFoldedPaper } from 'assets/icons';
import { useIsMobile } from 'hooks/common';
import styled from 'styled-components';

const EmptyBookingTicket = styled.div<{ $margin: string; $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  gap: 12px;

  height: 100%;
  margin: ${({ $margin, $isMobile }) =>
    $margin ? $margin : $isMobile ? '40px 0 64px' : '172px 0 24px'};

  > p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    color: rgba(70, 71, 76, 1);
  }
`;

interface Props {
  margin?: string;
  text?: string;
}

function EmptyList({ margin, text }: Props) {
  const isMobile = useIsMobile();

  return (
    <EmptyBookingTicket $isMobile={isMobile} $margin={margin}>
      <IconLeftBottomFoldedPaper width="40px" height="40px" />
      <p>{text || '예약 내역이 없어요.'}</p>
    </EmptyBookingTicket>
  );
}

export default EmptyList;
